import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBeF2ZLuJEfPX46BKiDcuO2XaJ_G5tMP80",
  authDomain: "brand-dashboard-f51aa.firebaseapp.com",
  projectId: "brand-dashboard-f51aa",
  storageBucket: "brand-dashboard-f51aa.firebasestorage.app",
  messagingSenderId: "1011388984203",
  appId: "1:1011388984203:web:b06b66d72a82bedcfc9d8e",
  measurementId: "G-14FDEZJT5Q",
};

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
export { analytics };
